{
  "close": "Затвори",
  "notifications": "Известия"
}
